import { getAPIURL, getFrontendURL } from 'src/utils/url';

export const BTNS = {
  /* 'FAKE': 'FAKE', */
  SEPARATOR: "SEPARATOR",
  GENERAL: "GENERAL",
  HEADER: "HEADER",
  FOOTER: "FOOTER",
  /* TABLE */
  TABLES: "TABLES",
  T_CABLES: "T_CABLES",
  T_BACK_BOXES: "T_BACK_BOXES",
  T_CAB_CONV: "T_CAB_CONV",
  T_NHC_DIN_DEVICES: "T_NHC_DIN_DEVICES",
  T_LOXONE_DIN_DEVICES: "T_LOXONE_DIN_DEVICES",
  T_RACK: "T_RACK",
  T_PRICES: "T_PRICES",
  T_DISCOUNTS: "T_DISCOUNTS",
  T_ARTICLENUMBERS: "T_ARTICLENUMBERS",
  T_DETAILS: "T_DETAILS",
  T_COMMENTS: "T_COMMENTS",
  /* MAP */
  FLOORMAPS: "FLOORMAPS",
  ROOMMAPS: "ROOMMAPS",
  MAP_SYMBOLS: "MAP_SYMBOLS",
  MAP_NOTES: "MAP_NOTES",
  MAP_WIRING: "MAP_WIRING",
  MAP_LIGHTING: "MAP_LIGHTING",
  MAP_WIFI: "MAP_WIFI",
  MAP_CAMERA: "MAP_CAMERA",
  /* PINOUT */
  PINOUT: "PINOUT",
  CABLE_LABELS: "CABLE_LABELS",
  SELECTED_CURRENCY: "SELECTED_CURRENCY",
  CURRENCY_VISIBILITY: "CURRENCY_VISIBILITY",
  //BOM
  BOM: "BOM",
  DISCOUNTS: "DISCOUNTS",
  COVER_PAGE: "COVER_PAGE",
  FUNCTION_DESCRIPTION: "FUNCTION_DESCRIPTION",
  CUSTOM_SECTION: "CUSTOM_SECTION",
  CLIENT_TYPE: "CLIENT_TYPE",
  TOTAL_PRICE: "TOTAL_PRICE",
  LABOUR_COST: "LABOUR_COST",
};

export const SECTION_TYPE = {
  TABLES: "tables",
  FLOOR: "floor",
  FLOOR_WIRING: "floor_wiring",
  FLOOR_CAMERA: "floor_camera",
  FLOOR_WIFI: "floor_wifi",
  ROOM: "room",
  ROOMS: "rooms",
  FUNCTION_TABLE: "functiontable",
  CONV_FUNCTION_TABLE: "convfunctiontable",
  NHC_DIN_TABLE: "nhcdintable",
  RACK_TABLE: "racktable",
  PROJECT_CABLES_TABLE: "projectcablestable",
  PROJECT_CUSTOM_TABLE: "projectcustomtable",
  SECTION_TABLE: "sectiontable",
  CUSTOM_SECTION: "custom_section",
  BOM: "bom",
  PINOUT: "pinout",
  LABELS: "labels",
  HEADER: "header",
  GENERAL_INFO: "generalinfo",
  DISCOUNTS: "discounts",
  BACK_BOXES: "backboxes",
  LIGHTING: "lighting",
  COVER_PAGE: "cover_page",
  FUNCTION_DESCRIPTION: "function_description",
  CLIENT_TYPE: "CLIENT_TYPE",
  TOTAL_PRICE: "total_price",
};


export const UNIT_TYPES = {
  M: "m",
  FT: "ft",
};

export const EMPTY_PROJECT_NAMES = [
  "Empty project",
  "Leeres Projekt",
  "Új projekt",
  "Proiect gol",
  "Leeg Project",
  "Nový projekt",
];

export const IMAGE_HOST = `${getFrontendURL()}/`;

export const LOXONE_ROW_ID = "(#LOXONE_PROGRAMMING_ROW#)";
export const SERVICEFEE_ROW_ID = "(#SERVICE_FEE_ROW#)";

export const ROOT_URI = getAPIURL() + '/v1'

export const EXPORTED_OFFER_DIV_ID = "exportedOfferDivId";

export const UNASSIGNED_ROOMTYPE_NAME= "Unassigned";

export const ZOHO_SALESIQ_WIDGET_SRC = "https://salesiq.zohopublic.eu/widget?wc=siqc0c2fc89e02c4b8463777fa37d7adc531c7f411e869ef218899929fbde4e64c5";

export const GlobalsVariables = {
  env: ""
}
export const SOFTWARE_VERSION_NUMBER = "9.0.3";
